import { formatCurrency } from '@/lib/utils/helpers'
import { useRouter } from 'next/navigation'
import { useEffect, useState } from 'react'
import styles from '../index.module.css'
import Icons from '../icons'
export default function StartupSummary({
  raised,
  target,
  minInvestment,
  stage,
  team = 0,
}) {
  const [getWindowSize, setWindowSize] = useState(0)

  useEffect(() => {
    setWindowSize(window?.innerWidth)
    window.addEventListener('resize', handleResize)
    return () => {
      window.addEventListener('resize', handleResize)
    }
  }, [])

  function handleResize() {
    setWindowSize(window?.innerWidth)
  }

  const progressPercentage = (raised / target) * 100
  const isOverFunding = raised > target
  const bgColor = isOverFunding ? 'bg-[#00AA99]' : ''

  return (
    <div className="flex flex-col gap-4 mx-[20px] sm:mx-0 ">
      <div className={`${styles.card}  flex items-center justify-between`}>
        <div className="flex flex-col gap-1">
          <div className="text-[#98A2B3] font-[400] text-xs">Stage</div>
          <div className="text-white font-[700] text-lg ">{stage}</div>
        </div>
        <div className="flex justify-center items-center bg-[#0075FF] w-[45px] h-[45px] rounded-[12px] ">
          <Icons iconName="stage" />
        </div>
      </div>
      <div className={`${styles.card}  flex items-center justify-between`}>
        <div className="flex flex-col gap-1">
          <div className="text-[#98A2B3] font-[400] text-xs">Team Size</div>
          <div className="text-white font-[700] text-lg ">{team || 0}</div>
        </div>
        <div className="flex justify-center items-center bg-[#0075FF] w-[45px] h-[45px] rounded-[12px] ">
          <Icons iconName="users" />
        </div>
      </div>
      <div className={`${styles.card} h-auto space-y-4 relative`}>
        <div className="text-[20px] font-[700] text-white">
          Investment Metrics
        </div>
        <div className="flex gap-5 items-center">
          <div className="flex flex-col gap-4">
            <div className={styles.statsCard}>
              <div className="text-xs text-[#98A2B3]">Targeted</div>
              <div
                className={`font-bold text-white ${
                  formatCurrency(target).length >= 15 && getWindowSize < 1300
                    ? 'text-xl'
                    : 'text-3xl'
                }`}
              >
                {formatCurrency(target)}
              </div>
            </div>
            <div className={styles.statsCard}>
              <div className="text-xs text-[#98A2B3]">
                Minimum Investment Amount
              </div>
              <div
                className={` font-bold text-white ${
                  formatCurrency(minInvestment).length >= 15 &&
                  getWindowSize < 1300
                    ? 'text-xl'
                    : 'text-3xl'
                }`}
              >
                {formatCurrency(minInvestment)}
              </div>
            </div>
            {/* <div className="relative">
              <img className="w-[206px]" src="/stats.png" alt="Statistics" />
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center">
                <div className="text-xs text-[#98A2B3]">Raised</div>
                <div className="text-lg font-bold text-white">
                  {formatCurrency(raised)}
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  )
}
